module.exports = {
      id: "check-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.26b8852d.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }